import React from 'react';

export const AnalyticsSkeleton: React.FC = () => {
    return (
        <div className="pb-8">
            <div className="px-[18px] pt-4 pb-2.5">
                <div className="h-5 w-32 bg-[var(--bg-hover)] rounded animate-pulse mb-2" />
                <div className="h-3 w-48 bg-[var(--bg-hover)] rounded animate-pulse" />
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 px-[18px] pb-3.5">
                {[...Array(4)].map((_, i) => (
                    <div key={i} className="h-[88px] bg-[var(--bg-elevated)] border border-[var(--border)] rounded-xl p-3.5">
                        <div className="h-3 w-20 bg-[var(--bg-hover)] rounded animate-pulse mb-3" />
                        <div className="h-6 w-24 bg-[var(--bg-hover)] rounded animate-pulse" />
                    </div>
                ))}
            </div>

            <div className="mx-[18px] h-[200px] bg-[var(--bg-elevated)] border border-[var(--border)] rounded-xl animate-pulse mb-3" />
            <div className="mx-[18px] h-[180px] bg-[var(--bg-elevated)] border border-[var(--border)] rounded-xl animate-pulse mb-3" />
            
            <div className="mx-[18px] h-[200px] bg-[var(--bg-elevated)] border border-[var(--border)] rounded-xl animate-pulse" />
        </div>
    );
};